import React, { useState, useMemo } from 'react';
import image1 from "../../images/datawithSS.png";
import image2 from "../../images/Rectangle 333 (1).png"
import image3 from "../../images/article (3).png"
import image6 from "../../images/Rectangle 333 (2).png"
import image8 from "../../images/Article (6).png"
import image4 from "../../images/Article (4).png"
import image7 from "../../images/Article (9).png"
import { Link } from 'react-router-dom';
// Structured Mock Data extracted from Figma Frame specifications
const INITIAL_CARDS = [
  {
    id: 1,
    type: 'EVENTS',
    tag: 'Eco Tech',
    title: 'Netzence set to unveil clean mobility hailing App in June 2026',
    excerpt: 'At a time when Nigeria’s cities are expanding at an unprecedented pace, and the strain on urban systems',
    readTime: '5 mins read',
    date: '2/3/2026',
    imageUrl: image1,
    typeColor: 'text-[#7BC216]',
    link:"/BlogPost5"
  },
  {
    id: 2,
    type: 'NEWS',
    tag: 'Climate change',
    title: 'Climate Reports Belong to the Public - Not the Shadows',
    excerpt: 'Average citizen that I am, I’d heard about climate change and wanted some accurate information about it...',
    readTime: '8 mins read',
    date: '18/2/2026',
    imageUrl: image2,
    typeColor: 'text-[#0D5EBA]',
    link:"/articlePost2"
  },
  {
    id: 3,
    type: 'ADVERT',
    tag: 'Carbon offset',
    title: 'Global Carbon Trading Markets: Frameworks and Projections',
    excerpt: 'In an era marked by climate urgency, social inequity, and an ever-evolving investment landscape, the practice of',
    readTime: '12 mins read',
    date: '21/2/2026',
    imageUrl: image3,
    typeColor: 'text-[#099137]',
    hasOverlayLogo: true,
    link:"/articlePost3"
  },
  {
    id: 4,
    type: 'ARTICLE',
    tag: 'Sustainable farming',
    title: 'Common Design Reusable Packaging: Doing More with Less',
    excerpt: 'Most of the goods we consume come with some sort of packaging. While the goods are consumed, the',
    readTime: '12 mins read',
    date: '2/3/2026',
    imageUrl: image4,
    typeColor: 'text-[#7BC216]',
    link:"/articlePost4"
  },
  {
    id: 5,
    type: 'ARTICLE',
    tag: 'Clean Energy',
    title: 'The Future of Corporate Sustainability and Climate Action in the Anti-“Woke” Era',
    excerpt: 'The Permanent Secretary, Federal Ministry of Environment, Mahmud Adam Kambari assured stakeholders.',
    readTime: '16 mins read',
    date: '18/2/2026',
    imageUrl: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&w=600&q=80',
    typeColor: 'text-[#7BC216]'
  },
  {
    id: 6,
    type: 'ARTICLE',
    tag: 'Clean Energy',
    title: 'Shared Responsibility for Climate Change: Who Should Fund the Solutions?',
    excerpt: "The UK's first geothermal plant in Cornwall generates renewable power and extracts lithium for EVs.",
    readTime: '10 mins read',
    date: '28/2/2026',
    imageUrl: image6,
    typeColor: 'text-[#7BC216]'
  },
  {
    id: 7,
    type: 'ARTICLE',
    tag: 'Climate Change',
    title: "What's the Difference Between Global Warming and Climate Change?",
    excerpt: 'The terms “global warming” and “climate change” are often used interchangeably. In the scientific literature...',
    readTime: '12 mins read',
    date: '15/01/2025',
    imageUrl: image7,
    typeColor: 'text-[#7BC216]'
  },
  {
    id: 8,
    type: 'ARTICLE',
    tag: 'Lifestyle ',
    title: "The Seven Stages of Climate Grief",
    excerpt: 'Exploring how investing in carbon offset initiatives can pave the way for a sustainable future.',
    readTime: '12 mins read',
    date: '15/01/2025',
    imageUrl: image8,
    typeColor: 'text-[#7BC216]'
  },
  {
    id: 9,
    type: 'ARTICLE',
    tag: 'Climate Change',
    title: "What's the Difference Between Global Warming and Climate Change?",
    excerpt: 'The terms “global warming” and “climate change” are often used interchangeably. In the scientific literature...',
    readTime: '12 mins read',
    date: '15/01/2025',
    imageUrl: 'https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?auto=format&fit=crop&w=600&q=80',
    typeColor: 'text-[#7BC216]'
  }
];

const CATEGORIES = ['All', 'News', 'Articles', 'Events'];

export default function ArticlesAndEventsGrid() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');

  // Combined Search & Filter Logic Routine
  const filteredCards = useMemo(() => {
    return INITIAL_CARDS.filter((card) => {
      const matchesCategory =
        activeCategory === 'All' ||
        card.type.toLowerCase() === activeCategory.toLowerCase() ||
        (activeCategory === 'Articles' && card.type === 'ARTICLE') ||
        (activeCategory === 'Events' && card.type === 'EVENTS');

      const matchesSearch =
        card.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        card.excerpt.toLowerCase().includes(searchQuery.toLowerCase()) ||
        card.tag.toLowerCase().includes(searchQuery.toLowerCase());

      return matchesCategory && matchesSearch;
    });
  }, [activeCategory, searchQuery]);

  return (
    <div className="w-full max-w-[1200px] mx-auto flex flex-col gap-[40px] px-4 py-8 lg:px-0">
      
      {/* Header Container Layout Area (Frame 2147228653) */}
      <div className="w-full flex flex-col gap-[32px]">
        <h2 className="text-[36px] font-medium text-black leading-[43px] ">
          Articles and Events
        </h2>

        {/* Filters and Navigation Control Belt (Frame 1618870784) */}
        <div className="w-full flex flex-col md:flex-row justify-between items-center gap-4 border-b border-gray-100 pb-4">
          
          {/* Segmented Filter Control Group (Frame 2147228652) */}
          <div className="flex flex-row items-center gap-[24px] h-[35px]">
            {CATEGORIES.map((category) => {
              const isActive = activeCategory === category;
              return (
                <button
                  key={category}
                  onClick={() => setActiveCategory(category)}
                  className={`text-[16px] font-normal  leading-[19px] transition-all px-[12px] py-[8px] rounded-[8px] flex items-center justify-center ${
                    isActive
                      ? 'bg-[#E7F6EC] text-[#0D924F] font-medium'
                      : 'text-[#3B3B3B] hover:text-black'
                  }`}
                >
                  {category}
                </button>
              );
            })}
          </div>

          {/* Search Input Bar Element (Frame 1618870780) */}
          <div className="flex flex-row items-center px-[12px] py-[16px] gap-[12px] w-full md:w-[331px] h-[52px] bg-[#FAFAFA] rounded-[12px] border border-gray-200/50 focus-within:border-gray-300 transition-all">
            {/* Custom SVG Search Icon */}
            <svg
              className="w-[20px] h-[20px] text-[#B1B1B1] shrink-0"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search news, articles here..."
              className="w-full bg-transparent text-[16px] font-normal  leading-[19px] text-[#3B3B3B] placeholder-[#B1B1B1] outline-none"
            />
          </div>
        </div>
      </div>

      {/* Grid Canvas Canvas Layout Area (Frame 2147228663) */}
      {filteredCards.length === 0 ? (
        <div className="w-full text-center py-20 text-gray-400  text-[16px]">
          No matching entries found for your active criteria.
        </div>
      ) : (
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-[30px] gap-y-[48px]">
          {filteredCards.map((card) => (
            <Link to={card.link} >
            <article
              key={card.id}
              className="relative w-full max-w-[384px] h-[497px] bg-white border border-[#E4E7EC] rounded-[12px] overflow-hidden group mx-auto hover:shadow-md transition-shadow duration-300"
            >
              {/* Media Container Box (Rectangle 333) */}
              <div className="relative w-full h-[289px] bg-[#FAFAFA] overflow-hidden border-b border-[#FAFAFA]">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-102 transition-transform duration-500"
                  loading="lazy"
                />
                
                {/* Embedded Floating Corporate Brand Stamp Overlay for Ads (Rectangle 334) */}
                {card.hasOverlayLogo && (
                  <div className="absolute right-[22px] bottom-[16px] w-[131.68px] h-[48px] bg-white/90 backdrop-blur-sm border border-[#FAFAFA] rounded-md flex items-center justify-center p-2 shadow-sm">
                    <span className="text-[11px] font-bold tracking-widest text-gray-700 font-sans">SPONSORED</span>
                  </div>
                )}
              </div>

              {/* Dynamic Content Cluster Frame (Frame 2147228661) */}
              <div className="absolute left-[14px] top-[307px] w-[calc(100%-28px)] h-[170px] flex flex-col justify-between">
                
                {/* Meta Badge Layer String Stack (Frame 2147228659) */}
                <div className="flex flex-col items-start gap-[11px]">
                  
                  {/* Category Stamp and Tag Row (Frame 2147228657) */}
                  <div className="flex flex-row items-center gap-[8px] h-[20px]">
                    <span className={`text-[16px] font-medium uppercase  leading-[19px] tracking-wider ${card.typeColor}`}>
                      {card.type}
                    </span>
                    
                    {/* Bullet Separation Node (Ellipse 706) */}
                    <div className="w-[6px] h-[6px] bg-[#8D8484] rounded-full" />
                    
                    {/* Industry Sector Node Label (Frame 2147228662) */}
                    <div className="flex flex-row justify-center items-center px-[6px] py-[3px] bg-[#3E3838] rounded-[2px]">
                      <span className="text-[12px] font-normal text-white  leading-[14px] whitespace-nowrap">
                        {card.tag}
                      </span>
                    </div>
                  </div>

                  {/* Text Header & Excerpt Module Group (Frame 2147228658) */}
                  <div className="flex flex-col items-start gap-[8px] w-full">
                    <h3 className="w-full text-[20px] font-medium text-[#3B3B3B] leading-[24px]  line-clamp-2 group-hover:text-black transition-colors">
                      {card.title}
                    </h3>
                    <p className="w-[332px] text-[14px] font-normal text-[#898989] leading-[17px]  line-clamp-2">
                      {card.excerpt}
                    </p>
                  </div>
                </div>

                {/* Footer Component Details Row */}
                <div className="flex flex-row justify-between items-center border-t border-gray-100 pt-3 w-full text-[14px] font-medium text-[#3B3B3B]  lowercase">
                  <span>{card.readTime}</span>
                  <span className="text-[12px] text-[#B1B1B1] font-normal normal-case">{card.date}</span>
                </div>

              </div>
            </article>
            </Link>

          ))}
        </div>
      )}
    </div>
  );
}